import * as React from 'react';
import { Helmet } from 'react-helmet';
import { FistColumn } from './columnOne';
import { SecondColumn } from './columnTwo';
import { PageWrapper } from './styles';

export const AdminSignIn = (): JSX.Element => {
  React.useEffect(() => {
    localStorage.setItem('coe-current-user', 'admin');
  }, []);

  return (
    <PageWrapper>
      <Helmet>
        <title>CoE exams officer sign in</title>
        <meta
          name="admin-signin"
          content="Sign in page for knust,
        college of engineering exams officer"
        />
      </Helmet>
      <FistColumn />
      <SecondColumn />
    </PageWrapper>
  );
};
